<template>
  <div class="others">
    <p class="title">{{$t("title")}}</p>
    <a class="btn-other xina" @click="login">{{$t("type1")}}</a>
    <a class="btn-other wechat">{{$t("type2")}}</a>
    <a class="btn-other twitter">{{$t("type3")}}</a>
    <!-- <wb:login-button type="3,2" onlogin="login" onlogout="logout">登录按钮</wb:login-button> -->
  </div>
</template>
<script>
export default {
  methods: {
    login(){
      let user = {
        loginState: true,
        userType: 20,
        uid: 2
      }
      this.$store.dispatch('SETUSER', user)
      this.$router.push({path: '/home'})
    }
  }
}
</script>
<style lang="scss" scoped>
.others{
  margin-top: 40px; position: relative; padding: 46px 20px 0; border-top: 1px solid #d5d5d5;
  .title{position: absolute; left: 50%; top: -10px; height: 20px; padding: 0 20px; background: #fff; transform: translateX(-50%); color: #5d5d5d;}
  &:after{display: block; clear: both; content: '';}
  .btn-other{
    float: left; width: 33.33%; text-align: center; color: #2c2c2c;
    &:before{display: block; content: ''; height: 34px; background: url(../assets/xina.png) no-repeat center top;}
    &:hover{opacity: .7;}
  }
  .wechat:before{background-image: url(../assets/wechat.png);}
  .twitter:before{background-image: url(../assets/twitter.png);}
}
</style>
<i18n>
{
  "cn": {
    "title": "第三方登录",
    "type1": "微博登录",
    "type2": "微信登录",
    "type3": "推特登录"
  },
  "TW": {
    "title": "協力廠商登入",
    "type1": "微博登入",
    "type2": "微信登入",
    "type3": "推特登入"
  },
  "en": {
    "title": "Third party login",
    "type1": "Login via Weibo",
    "type2": "Login via Wechat",
    "type3": "Login in via Twitter "
  }
}
</i18n>